import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react/components/Loading/Loading';

function HelperAssignmentItem({ assignment, canBeRemoved, unassignHelper }) {
  const [isLoading, setIsLoading] = useState(false);

  const { helper } = useMemo(() => assignment, [assignment]);

  function handleUnassignHelper() {
    setIsLoading(true);

    unassignHelper(
      assignment,
      () => {
        setIsLoading(false);
      },
      () => {
        setIsLoading(false);
      }
    );
  }

  const rightIcon = useMemo(() => {
    if (canBeRemoved && !isLoading) {
      return (
        <button
          type="button"
          data-testid={`helper-${helper.key}-remove-icon-button`}
          onClick={handleUnassignHelper}
          className="remove-icon"
        />
      );
    }

    if (isLoading) {
      return <Loading width="20px" height="20px" />;
    }

    return null;
  }, [canBeRemoved, isLoading]);

  return (
    <div data-testid={`helper-assignment-${helper.key}`} className="helper-assigned">
      <div className="helper-name">
        <p>{`${helper.key} - ${helper.name}`}</p>
      </div>
      {rightIcon}
    </div>
  );
}

HelperAssignmentItem.propTypes = {
  assignment: PropTypes.shape({
    helper: PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  canBeRemoved: PropTypes.bool.isRequired,
  unassignHelper: PropTypes.func.isRequired
};

export default HelperAssignmentItem;
